<script setup lang="ts">
  import { INodeComplementLinkProps, ITaxationProps, ITaxationsProps } from '@/types'
  import { Typography, DetailsTaxAccordion } from '@components/index'

  const props = defineProps<ITaxationsProps>()

  const emit = defineEmits(['onOpenModal'])

  const currentPage = ref<number>(0)
  const currentTitle = ref<string[]>([])
  const itemList = ref<ITaxationProps[][]>([props.taxations])

  const handleClickBackTo = (index: number): void => {
    while (itemList.value.length > index + 1) {
      itemList.value.pop()
      currentTitle.value.pop()
    }
    currentPage.value = index
  }

  const loadNextPage = (taxations: ITaxationProps[], title: string): void => {
    if (taxations.length > 0) {
      itemList.value.push(taxations)
      currentTitle.value.push(title)
      currentPage.value++
    }
  }

  const handleSpanClick = (data: INodeComplementLinkProps) => {
    emit('onOpenModal', data)
  }
</script>

<template>
  <div class="col">
    <Typography variant="regulation-topic">{{ props.title }}</Typography>
    <div
      v-if="currentPage > 0"
      class="mt-1 d-flex flex-column"
    >
      <Typography variant="breadcrumb">
        <template
          v-for="(title, index) in currentTitle"
          :key="index"
        >
          <span
            v-if="index > 0"
            class="mx-1"
          >
            /
          </span>
          <button
            class="bread"
            @click="handleClickBackTo(index)"
          >
            {{ title.length > 30 ? title.slice(0, 30) + '...' : title }}
          </button>
        </template>
      </Typography>
    </div>
    <!-- Pages -->
    <div
      class="mt-1 d-flex flex-column"
      :class="[currentPage > 0 ? 'pb-3' : 'pt-2; pb-3']"
    >
      <div :key="currentPage">
        <div
          v-for="(item, index) in itemList[currentPage]"
          :key="index"
          class="mb-1"
        >
          <DetailsTaxAccordion
            :title="item.title"
            :description="item.description"
            :taxations="item.taxations"
            @on-open-modal="handleSpanClick"
            @on-next-page="loadNextPage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .container {
    max-width: 660px;
    overflow: hidden;
  }

  .bread {
    background: none;
    border: none;
    cursor: pointer;
    text-align: left;
  }
</style>
